import { Component, OnInit, ViewChild } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { UsersInactiveModel } from '../../models/users-inactive.model'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import * as moment from 'moment'
import { PortalGlobals } from '../../../../app/portalglobals'
import { SearchModel } from '../../models/enrollment-search-details'
import { JqxGridVirtualPaging } from '../../../common/utilclasses/jqxgrid-virtualpaging'
import * as _ from 'lodash'
import { ExcelService } from '../../excel.service'

@Component({
    selector: 'usersinactive',
    templateUrl: 'users-inactive.component.html'
})
export class UsersInactiveComponent implements OnInit {
    usersearchmodel: UsersInactiveModel[] | null = []
    startdate: Date
    enddate: Date
    saveSuccess: string
    message: string
    loading: boolean
    fmoModelPortal: SearchModel
    totalCount: number = 0
    jqxgridvirtualpaging: JqxGridVirtualPaging
    public loadingusers: boolean = false
    showUsersSearch: boolean = false
    chunkSize: number = 10000
    public loadingPDF: boolean = false
    public errors: any[] = []
    public isFormValid: boolean = true
    @ViewChild('usersearchgrid', { static: true }) UserSearchGrid: jqxGridComponent

    Source: any = {
        dataFields: [
            { name: 'LoginID', type: 'string' },
            { name: 'User_type', type: 'string' },
            { name: 'Name', type: 'string' },
            { name: 'Userprofilestatuscode', type: 'string' },
            { name: 'ChangedBy', type: 'string' },
            { name: 'TrackingDate', type: 'string' }
        ],
        dataType: 'json',
        localData: this.usersearchmodel,
        totalrecords: this.totalCount,
        pagenum: 0,
        pagesize: 50
    }

    ready = (): void => {
        this.UserSearchGrid.localizestrings(this.jqxgridvirtualpaging.ready())
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxgridvirtualpaging.updatefilterconditions(type)
    }

    onSortPortal(event: any): void {
        this.onSort(event, this.fmoModelPortal)
        this.GetUserSearchData(this.fmoModelPortal)
    }
    onSort(event: any, fmoModel: SearchModel): void {
        let sortinformation = event.args.sortinformation
        let sortdirection = sortinformation.sortdirection.ascending ? 'ASC' : 'DESC'
        if (!sortinformation.sortdirection.ascending && !sortinformation.sortdirection.descending) {
            sortdirection = ''
        }
        if (sortdirection) {
            fmoModel.SortFields = `${sortinformation.sortcolumn} ${sortdirection}`
        } else {
            fmoModel.SortFields = ''
        }
    }
    onPortalPageSizeChanged(event: any): void {
        let args = event.args
        this.Source.pagesize = this.fmoModelPortal.PageSize = args.pagesize

        this.GetUserSearchData(this.fmoModelPortal)
    }

    onFilter(event: any): void {
        let filterinfo = this.UserSearchGrid.getfilterinformation()
        this.fmoModelPortal.FilterCriteria = this.jqxgridvirtualpaging.onFilter(event, filterinfo)
        this.GetUserSearchData(this.fmoModelPortal)
    }

    columns: any[] = [
        { text: 'Login ID', dataField: 'LoginID', width: 250 },
        { text: 'User Type', dataField: 'User_type', width: 250 },
        { text: 'Name', dataField: 'Name', width: 200 },
        { text: 'Status', dataField: 'Userprofilestatuscode', width: 150 },
        { text: 'ChangedBy', dataField: 'ChangedBy', width: 180 },
        { text: 'ChangedDate', dataField: 'TrackingDate', width: 200 }
    ]
    dataAdapter: any = new jqx.dataAdapter(this.Source)

    renderPortalGridRows = (params: any): any[] | null => {
        if (params.data.length > this.fmoModelPortal.PageSize) {
            params.endindex = params.data.length
            params.startindex = params.data.length - this.fmoModelPortal.PageSize
        }
        if (!isNaN(params.startindex)) {
            this.fmoModelPortal.PageNumber = Math.floor(params.startindex / this.fmoModelPortal.PageSize) + 1
            this.loading = true
            this.usersearchmodel = this._reportsGateway.getInactiveUsersSync(this.fmoModelPortal)

            if (this.usersearchmodel !== undefined && this.usersearchmodel.length > 0) {
                this.usersearchmodel.map(
                    (row) => {
                        row.TrackingDate = moment(row.TrackingDate).format('M/D/YYYY')
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.loading = false
            }
        }
        return this.usersearchmodel
    }

    validateForm() {
        this.errors = []
        this.isFormValid = true
        if (this.fmoModelPortal.StartDate === null || this.fmoModelPortal.StartDate === undefined || this.fmoModelPortal.StartDate === '') {
            this.errors.push('Start date cannot be empty')
            this.isFormValid = false
        }
        if (this.fmoModelPortal.EndDate === null || this.fmoModelPortal.EndDate === undefined || this.fmoModelPortal.EndDate === '') {
            this.errors.push('End date cannot be empty')
            this.isFormValid = false
        }
    }

    GetUserSearchData(UserModel: SearchModel) {
        this.loading = true
        this.validateForm()
        if (this.isFormValid) {
            if (UserModel === undefined || UserModel === null) UserModel = this.fmoModelPortal

            this._reportsGateway.getInactiveUsers(UserModel).subscribe(
                (usersinactive: UsersInactiveModel[]) => {
                    if (usersinactive.length > 0) {
                        this.showUsersSearch = true
                        this.usersearchmodel = usersinactive
                        this.Source.localdata = this.usersearchmodel
                        this.totalCount = this.Source.totalrecords = usersinactive[0].TotalCount || 0

                        this.dataAdapter.dataBind()
                        this.UserSearchGrid.updatebounddata()
                        this.loading = false
                        this.message = ''
                    } else {
                        this.usersearchmodel = null
                        this.Source.localdata = this.usersearchmodel
                        this.totalCount = 0

                        this.dataAdapter.dataBind()
                        this.UserSearchGrid.updatebounddata()

                        this.showUsersSearch = false
                        this.message = 'No Data Found'
                    }
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                }
            )
        } else {
            this.loading = false
        }
    }

    constructor(private _reportsGateway: ReportsGateway, private _excelService: ExcelService, public _global: PortalGlobals) {
        this.jqxgridvirtualpaging = new JqxGridVirtualPaging()
    }

    ngOnInit() {
        this.fmoModelPortal = {} as SearchModel
        let today = new Date()
        var year = 0
        if (this._global.selectedPlanYear == undefined || this._global.selectedPlanYear == null || this._global.selectedPlanYear == 0) {
            year = Number(localStorage.getItem('curPlanYear'))
        } else {
            localStorage.setItem('curPlanYear', this._global.selectedPlanYear.toString())
            year = this._global.selectedPlanYear
        }

        var day = 7
        this.fmoModelPortal.StartDate = moment(today).subtract(day, 'day').format('M/D/YYYY')
        console.log('start date: ' + this.startdate)

        this.fmoModelPortal.EndDate = moment(today).format('M/D/YYYY')
        this.saveSuccess = ''

        this.fmoModelPortal.PageNumber = 1
        this.fmoModelPortal.PageSize = 50
        //this.GetUserSearchData(this.FilterCriteria.startDate, this.FilterCriteria.endDate)
    }

    ExportToExcel() {
        this.validateForm()
        if (this.isFormValid) {
            this.onExport(this.fmoModelPortal, 'Inactive Users', this.totalCount)
        }
    }

    onExport(FmoModel: SearchModel, title: string, totalCount: number) {
        let pageNumber = FmoModel.PageNumber
        let pageSize = totalCount
        this.loading = true
        let usersData: UsersInactiveModel[] = [] as UsersInactiveModel[]

        FmoModel.PageNumber = 1
        FmoModel.PageSize = totalCount
        usersData = this.pickGateWayMethod(FmoModel, title)
    }

    pickGateWayMethod(model: SearchModel, title: string) {
        let data: UsersInactiveModel[] = [] as UsersInactiveModel[]
        let pageNumber = model.PageNumber
        let pageSize = model.PageSize

        this._reportsGateway.getInactiveUsers(model).subscribe(
            (data) => {
                data = data

                for (var i = 0; i < data.length; i++) {
                    var row = data[i]
                    if (row.TrackingDate !== null) {
                        row.TrackingDate = moment(row.TrackingDate).format('M/D/YYYY')
                    }
                }

                let array = _.clone(data)

                array.forEach(function (v) {
                    delete v.TotalCount
                })

                let strArray = JSON.stringify(array)
                strArray = strArray.replace(/Name/g, 'Name')
                strArray = strArray.replace(/LoginID/g, 'Login ID')
                strArray = strArray.replace(/User_type/g, 'User Type')
                strArray = strArray.replace(/Userprofilestatuscode/g, 'Status')
                strArray = strArray.replace(/ChangedBy/g, 'Changed By')
                strArray = strArray.replace(/TrackingDate/g, 'Changed Date')

                let modEnrollmentData = JSON.parse(strArray)
                this._excelService.exportAsExcelFile(modEnrollmentData, title)
                model.PageNumber = pageNumber
                model.PageSize = pageSize
                this.loading = false
            },
            (error) => {
                this.loading = false
            }
        )

        return data
    }
}
